import React from 'react';
import PropTypes from 'prop-types';
import AdSense from './AdSense';

/**
 * AdInArticle Component
 * 
 * An in-article ad that adapts to the content width
 * Designed to be placed between paragraphs in article content
 * 
 * @param {Object} props Component props
 * @param {string} props.adSlot The ad unit ID
 * @param {Object} props.style Additional inline styles
 * @param {string} props.className Additional CSS classes
 */
const AdInArticle = ({ adSlot, style, className }) => {
  const inArticleStyle = {
    width: '100%',
    height: '200px',
    margin: '20px 0',
    ...style
  };
  
  return (
    <AdSense
      adSlot={adSlot}
      adFormat="fluid"
      style={inArticleStyle}
      className={`ad-in-article ${className || ''}`}
    />
  );
};

AdInArticle.propTypes = {
  adSlot: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string
};

AdInArticle.defaultProps = {
  adSlot: 'in-article-ad-slot',
  style: {},
  className: ''
};

export default AdInArticle; 